/* ============================================================
  RC BESPOKE ADD TO CART: Adds setting + diamond simultaneously with all properties
============================================================ */

/* ========= GENERATE UNIQUE KEY ========= */
function rcGenerateUniqueKey() {
  return Math.random().toString(36).substring(2, 12);
}

/* ========= FORMAT DIAMOND TITLE ========= */
function rcFormatDiamondTitle(diamond) {
  return `${diamond.shape} #${diamond.cert_num}`;
}

/* ========= FORMAT CARAT ========= */
function rcFormatCarat(size) {
  return `${parseFloat(size || 0)}ct`;
}

/* ========= FORMAT MEASUREMENTS ========= */
function rcFormatMeasurements(diamond) {
  if (diamond.dimensions) return diamond.dimensions;
  if (diamond.meas_length && diamond.meas_width && diamond.meas_depth) {
    return `${parseFloat(diamond.meas_length).toFixed(2)} x ${parseFloat(diamond.meas_width).toFixed(2)} x ${parseFloat(diamond.meas_depth).toFixed(2)}`;
  }
  return '';
}

/* ========= GET DIAMOND SHOPIFY VARIANT ID ========= */
function rcGetDiamondVariantId() {
  try {
    const shopifyData = localStorage.getItem('selected-diamond-shopify-data');
    if (!shopifyData) return null;
    const parsed = JSON.parse(shopifyData);
    /* Handle both product object and variants array */
    const variants = parsed?.variants || parsed?.product?.variants;
    return variants?.[0]?.id || null;
  } catch (e) {
    return null;
  }
}

/* ========= BUILD SETTING PROPERTIES ========= */
function rcBuildSettingProperties(diamond, diamondVariantId, uniqueKey, ringSize) {
  const carat = rcFormatCarat(diamond.size);
  const measurements = rcFormatMeasurements(diamond);
  const cut = diamond.shape === 'Round' ? (diamond.cut || 'Excellent') : 'Excellent';
  const diamondType  = diamond.lg ? 'Lab Grown Diamond' : 'Natural Diamond';
  const markupPrice  = `$${Number(diamond.marked_up_price || diamond.total_sales_price || 0).toLocaleString()}`;
  const props = {
    'Diamond':                  `${diamond.shape} #${diamond.cert_num}`,
    'DiamondId':                String(diamondVariantId),
    'Carat':                    carat,
    'Clarity':                  diamond.clarity || '',
    'Cut':                      cut,
    'Color':                    diamond.color || '',
    'Diamond Measurement':      measurements,
    '_markupPrice':             markupPrice,
    'Diamond Type':             diamondType,
    '_associated_unique_key':   uniqueKey
  };
  if (ringSize) props['Ring_Size'] = ringSize;

  return props;
}

/* ========= BUILD DIAMOND PROPERTIES ========= */
function rcBuildDiamondProperties(diamond, settingVariantId, uniqueKey) {
  const carat        = rcFormatCarat(diamond.size);
  const measurements = rcFormatMeasurements(diamond);
  const cut          = diamond.shape === 'Round'
    ? (diamond.cut || 'Excellent')
    : 'Excellent';

  return {
    'Carat':                    carat,
    'Clarity':                  diamond.clarity || '',
    'Cut':                      cut,
    'Color':                    diamond.color || '',
    'Diamond Measurement':      measurements,
    'Diamond':                  diamond.lg ? 'Lab Grown Diamond' : 'Natural Diamond',
    '_dp_identifier':           `${Number(diamond.marked_up_price || diamond.total_sales_price || 0).toFixed(2)}`,
    '_gia_cert_number':         String(diamond.cert_num || ''),
    '_associated_unique_key':   uniqueKey,
    'Lead Time':                'Only a few left!'
  };
}

/* ========= MAIN: ADD TO CART ========= */
async function rcBespokeAddToCart(redirectTo = '/cart') { 
  const btnId = redirectTo === '/cart' ? 'rc-pre-cart-add-to-cart' : 'rc-pre-cart-checkout-now';
  const btn = document.getElementById(btnId);

  /* === Get diamond from localStorage === */
  let diamond = null;
  try {
    diamond = JSON.parse(localStorage.getItem('rc_selected_diamond'));
  } catch (e) {}

  if (!diamond) {
    console.warn('RC: No diamond selected');
    return;
  }

  /* === Get diamond Shopify variant ID === */
  const diamondVariantId = rcGetDiamondVariantId();
  if (!diamondVariantId) {
    console.warn('RC: Diamond Shopify variant ID not found in selected-diamond-shopify-data');
    rcShowCartError(btn, 'Diamond product not ready. Please try again.');
    return;
  }

  /* === Get setting variant ID from URL === */
  const urlParams       = new URLSearchParams(window.location.search);
  const settingVariantId = urlParams.get('variant');
  const ringSize         = urlParams.get('Ring_Size') || '';

  if (!settingVariantId) {
    console.warn('RC: Setting variant ID not found in URL');
    rcShowCartError(btn, 'Setting variant not found. Please try again.');
    return;
  }

  /* === Generate shared unique key === */
  const uniqueKey = rcGenerateUniqueKey();
  /* === Build both items === */
  const settingProperties = rcBuildSettingProperties(diamond, diamondVariantId, uniqueKey, ringSize); 
  const diamondProperties = rcBuildDiamondProperties(diamond, settingVariantId, uniqueKey);

  const payload = {
    items: [
      { id: parseInt(settingVariantId), quantity: 1, properties: settingProperties },
      { id: parseInt(diamondVariantId), quantity: 1, properties: diamondProperties }
    ]
  };

  /* === Loading state === */
  rcSetCartBtnLoading(true, redirectTo); 

  try {
    const response = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.description || 'Failed to add to cart');
    }

    /* === Success: clear localStorage and redirect to cart === */
    clearBespokeSelectedData();
    window.location.href = redirectTo;  // Dynamic redirect

  } catch (err) {
    console.error('RC Add to Cart Error:', err);
    rcShowCartError(btn, err.message || 'Something went wrong. Please try again.');
  } finally {
    rcSetCartBtnLoading(false, redirectTo);
  }
}

/* ========= BUTTON LOADING STATE ========= */
function rcSetCartBtnLoading(isLoading, redirectTo) {
  const addBtn      = document.getElementById('rc-pre-cart-add-to-cart');
  const checkoutBtn = document.getElementById('rc-pre-cart-checkout-now');
  const clickedBtn  = redirectTo === '/cart' ? addBtn : checkoutBtn;
  const otherBtn    = redirectTo === '/cart' ? checkoutBtn : addBtn;
  const buttons     = [addBtn, checkoutBtn].filter(Boolean);

  if (isLoading) {
    if (clickedBtn) {
      clickedBtn.dataset.originalText = clickedBtn.textContent;
      clickedBtn.textContent = 'Adding...';
    }
    buttons.forEach(btn => { if (btn) btn.disabled = true; });
  } else {
    buttons.forEach(btn => {
      if (!btn) return;
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || btn.textContent;
    });
  }
}

/* ========= SHOW ERROR ========= */
function rcShowCartError(btn, message) {
  const wrapper = btn?.closest('.rc-pre-cart-cta-wrapper');
  if (!wrapper) return;

  let errorEl = wrapper.querySelector('.rc-cart-error');
  if (!errorEl) {
    errorEl = document.createElement('p');
    errorEl.className = 'rc-cart-error';
    errorEl.style.cssText = 'color: red; font-size: 12px; margin-top: 8px;';
    wrapper.appendChild(errorEl);
  }
  errorEl.textContent = message;
}

/* ========= BIND BUTTONS ========= */
document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('rc-pre-cart-add-to-cart')?.addEventListener('click', () => rcBespokeAddToCart('/cart'));         
  document.getElementById('rc-pre-cart-checkout-now')?.addEventListener('click', () => rcBespokeAddToCart('/checkout'));   
});